module.exports = __webpack_public_path__ + "img/left_md_4.62a662e0.jpg";